import { Button, Container, Grid, Text } from "basis";
import { Dispatch, FC } from "react";
import { usePageTracking } from "react-event-tracker";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";
import { START_CLICKED } from "./constants";
import { ImportantInformationList } from "./ImportantInformationList";
import { Action, State } from "./types";

interface Props {
  state: State;
  dispatch: Dispatch<Action>;
}

export const CanReduce: FC<Props> = ({ state, dispatch }) => {
  usePageTracking({
    page: {
      pageType: "config-page",
      siteSection: "accounts",
      siteSubSection: "manage",
      pageTitle: "reduce-credit-limit",
    },
    user: {
      authenticationStatus: "logged in",
    },
  });
  return (
    <Grid rowsGap="8">
      <Container bg="grey.t05" padding="4">
        {state.accountInfo && (
          <CreditCard
            cardName={state.accountInfo.cardName}
            cardEndsWith={state.accountInfo.cardEndsWith}
          />
        )}
      </Container>
      <SvgInline name="reduce-credit-limit" size="92" />
      <Text as="h3" textStyle="heading5" textStyle-sm="heading4">
        Set a limit that makes you feel comfortable
      </Text>
      <Container bg="secondary.lightBlue.t25" padding="4">
        <Container bg="white" padding="6">
          <Text margin="0 0 4 0">
            <strong>
              Here’s some important information you’ll need to know about
              reducing your credit limit.
            </strong>
          </Text>
          <ImportantInformationList />
        </Container>
      </Container>
      <Container>
        <Button
          width="100%"
          width-xs="196"
          onClick={(): void => {
            dispatch({ type: START_CLICKED });
          }}
        >
          Start
        </Button>
      </Container>
    </Grid>
  );
};
